/*
|-------------------------------------------------------------------------------
| 征信授权
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * 维护业务数据 需要提交到后端的数据
 */
const AuthorizationStore = defineStore({
  state: () => ({
    page: '', // 后端返回的页面标识
    // 拒量引流协议选项
    // loanAgreement: {
    //   agreeInfoSync: false,
    //   agreeApplyCashLoan: false,
    // },
    isEvaChecked: false, // 是否勾选eva
    code: '', // 验证码
    hasRefusesAttractContract: false, // 是否展示双征信协议
  }),
  mutations: {
    updatePage(state, data) {
      state.page = data
    },
    updateIsEvaChecked(state, data) {
      state.isEvaChecked = data
    },
    updateCode(state, data) {
      state.code = data
    },
    updateHasRefusesAttractContract(state, data) {
      state.hasRefusesAttractContract = data
    },
    update(state, data) {
      Object.assign(state, data)
    },
  },
})

export default AuthorizationStore
export type IAuthorizationStoreState = IStoreState<
  typeof AuthorizationStore.state
>
